import { render, staticRenderFns } from "./TopfansCase.vue?vue&type=template&id=1125911d&scoped=true&"
import script from "./TopfansCase.vue?vue&type=script&lang=js&"
export * from "./TopfansCase.vue?vue&type=script&lang=js&"
import style0 from "./TopfansCase.vue?vue&type=style&index=0&id=1125911d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1125911d",
  null
  
)

export default component.exports